import React, {ReactText, FC} from 'react';
import {useDispatch} from 'react-redux';

import {ITableActionProps} from 'components/table/action';
import {ActionButton} from 'components/table/action/action-button';
import {ActionConfirmModal} from 'components/table/action/action-confirm-modal/action-confirm-modal';
import {selectMetadata} from 'entities/metadata';
import {selectEntityData} from 'modules/data';
import {createActionHandlerForDelete} from 'modules/data/data-actions';
import {ITableEntityData} from 'modules/data/data-types';
import {EEntityType} from 'shared/constants/entities';
import {ERequestType} from 'shared/types/requests';
import {useAppSelector} from 'store/config/hooks';

import {
    DELETE_INVEST_PROJECT_CONFIRM_TEXT, DELETE_INVEST_PROJECT_WARN_TEXT
} from '../project-investment-info-item-modal/model/project-investment-info-item-modal.constants';

interface IButtonActionForDeleteRowsOwnProps extends ITableActionProps {
  activeRows?: string[];
}

export const ButtonActionForProjectInvestmentRows: FC<IButtonActionForDeleteRowsOwnProps> = ({
  wrapper,
  meta,
  entityName,
  activeRows = [],
  ...props
}: IButtonActionForDeleteRowsOwnProps) => {
  const referenceUrl = meta?.referenceUrl || entityName;
  const requestType = meta?.requestType || ERequestType.POST;
  const {urlConfig} = useAppSelector(selectMetadata(entityName, EEntityType.TABLE)) || {};

  const {selectedRowKeys = []} = useAppSelector(selectEntityData(entityName, EEntityType.TABLE)) as ITableEntityData
  ?? {};

  const dispatch = useDispatch();
  const actionsForRows = (ids: ReactText[]) => dispatch(
      createActionHandlerForDelete({
        entityName,
        referenceUrl,
        requestType,
        itemList: meta?.itemListKey ? {[meta.itemListKey]: ids} : {ids},
        urlConfig: meta?.shouldIgnoreUrlConfig ? undefined : urlConfig,
      }),
  );
  const handleDelete = () => {
    actionsForRows(selectedRowKeys);
  };
  const Component = wrapper || ActionButton;

  const confirmModalContent: string|string[] =
      activeRows?.length ? [DELETE_INVEST_PROJECT_WARN_TEXT, 'Активные записи:', ...activeRows] : DELETE_INVEST_PROJECT_CONFIRM_TEXT;

  return (
      <ActionConfirmModal
          cancelText="Отмена"
          approveText={!activeRows?.length ?  'Удалить' : undefined}
          modalTitle={activeRows?.length ? 'Внимание!' : 'Удаление'}
          confirmModalContent={confirmModalContent}
          confirmAction={handleDelete}
      >
        {handleClick => (
            <Component
                {...props}
                onClick={handleClick}
                actionIcon={meta.actionIcon}
                disabled={!selectedRowKeys.length}
                className="table-action critic-action"
            >
              {meta.actionTitle}
            </Component>
        )}

      </ActionConfirmModal>
  );
};
